<template>
  <div class="card text-center shadow-sm animate__animated animate__fadeInUp">
    <div class="card-body">
      <h5 class="card-title fs-6">{{ title }}</h5>
      <h2 :class="colorClass">{{ value }}</h2>
      <div v-if="subtitle" class="text-muted medium mt-1">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: String,
  value: [String, Number],
  color: {
    type: String,
    default: 'primary',
  },
  subtitle: String,
});

const colorClass = `text-${props.color} `;
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
</style>
